<template>
  <div>
    <Card>
      <ui-date-picker mode="range" :columns="2"></ui-date-picker>
    </Card>
    <Card>
      <ui-date-picker :min-date="new Date()" mode="single"></ui-date-picker>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
